import React, { forwardRef } from 'react';
import { element, func } from 'prop-types';
import Scrollbars from "../../../../../Scrollbar";
export var Scrollbar = /*#__PURE__*/forwardRef(function Scrollbar(_ref, ref) {
  var onScroll = _ref.onScroll,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Scrollbars, {
    ref: ref,
    onScroll: onScroll
  }, children);
});
Scrollbar.propTypes = process.env.NODE_ENV !== "production" ? {
  children: element,
  onScroll: func
} : {};